/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */
import { PipeTransform, Pipe } from "@angular/core";
import { AB } from "../../desktop/common/appblast-util.service";

@Pipe({
   standalone: false,
   name: "availableItemsFilter",
   pure: false
})
export class AvailableItemsPipe implements PipeTransform {
   constructor() {}
   transform(availableItems, query, onlyFavorites) {
      const getAvailableItem = (availableItem) => {
         if (!AB.itemNameContainsQuery(availableItem, query) || (onlyFavorites && !availableItem.favorite)) {
            return false;
         } else {
            return true;
         }
      };
      return availableItems.filter(getAvailableItem);
   }
}
